import { useMemo } from "react";
import { useFormikContext } from "formik";
import { useActionChoices } from "stores";
import { TASKS } from "constants/actions";
import DiagnoseDetails from "./diagnose/DiagnoseDetails";
import OtherActionDetails from "./other/OtherActionDetails";
import WateringDetails from "./watering/WateringDetails";
import FertilizeDetails from "./fertilize/FertilizeDetails";
import DrugDetails from "./drug/DrugDetails";
import ObservationActionDetails from "./observation/ObservationActionDetails";

const ActionDetails = ({ viewMode, actionStatus, isNewVersion }) => {
  const { values } = useFormikContext();
  const { getActionById } = useActionChoices();

  const action = useMemo(
    () => getActionById(values.taskId),
    [getActionById, values?.taskId],
  );

  switch (action) {
    case TASKS.watering:
      return <WateringDetails viewMode={viewMode} status={actionStatus} isNewVersion={isNewVersion} />;
    case TASKS.drug:
      return <DrugDetails viewMode={viewMode} status={actionStatus} isNewVersion={isNewVersion} />;
    case TASKS.fertilize:
      return <FertilizeDetails viewMode={viewMode} status={actionStatus} isNewVersion={isNewVersion} />;
    case TASKS.diagnose:
      return <DiagnoseDetails viewMode={viewMode} status={actionStatus} isNewVersion={isNewVersion} />;
    case TASKS.other:
      return <OtherActionDetails viewMode={viewMode} status={actionStatus} isNewVersion={isNewVersion} />;
    case TASKS.observation:
      return (
        <ObservationActionDetails viewMode={viewMode} status={actionStatus} />
      );
    default:
      return <></>;
  }
};

export default ActionDetails;
